const clearPasswordFields = () => {
  document.addEventListener('wpcf7mailsent', function(event) {
    const form = event.target;
    const passwordFields = form.querySelectorAll('.wpcf7-password');

    passwordFields.forEach(field => {
      field.value = '';
      field.classList.remove('wpcf7-not-valid');
      const errorEl = field.parentNode.querySelector('.input-error');
      if (errorEl) errorEl.remove();
    });
  }, false);
};

export default clearPasswordFields;
